import {
  PlaceCardHeader,
  PlaceCardContext,
  PlaceCardValueSummary,
  PlaceCardUnavailable,
  selectPrimaryGroup,
  buildContextSentence,
} from './place-card-sections';
import type { PlaceValueResponse } from './place-value-api';
import type { MapPlaceReading } from './vsj-map-place-api';

interface PlaceValueCardProps {
  data: PlaceValueResponse;
  reading: MapPlaceReading | null;
  onClose: () => void;
  onAction?: (action: string) => void;
}

/**
 * Ficha del lugar — the exploration map's territorial reading.
 * Narrative order: place → entorno → value reference → action → disclaimer.
 */
export function PlaceValueCard({
  data,
  reading,
  onClose,
  onAction,
}: PlaceValueCardProps): JSX.Element {
  const groups = data.status === 'available' ? data.market.groups : [];
  const primaryGroup = selectPrimaryGroup(groups);
  const otherGroups = primaryGroup ? groups.filter(g => g !== primaryGroup) : [];
  const contextSentence = reading ? buildContextSentence(reading) : null;

  return (
    <>
      <PlaceCardHeader reading={reading} onClose={onClose} />

      <div className="vsj-pvc-body">
        {contextSentence && <PlaceCardContext sentence={contextSentence} />}

        {data.status === 'available' && primaryGroup && (
          <PlaceCardValueSummary primary={primaryGroup} others={otherGroups} />
        )}

        {data.status === 'insufficient_data' && <PlaceCardUnavailable />}

        {onAction && (
          <button
            type="button"
            className="vsj-pvc-action-btn vsj-pvc-action-btn--full"
            onClick={() => onAction('tasar')}
          >
            Consultar valor acá
          </button>
        )}

        <p className="vsj-pvc-disclaimer">
          Referencias de avisos publicados. No reemplazan una tasación profesional.
        </p>
      </div>
    </>
  );
}
